import { render, staticRenderFns } from "./SMSTemplatesTab.vue?vue&type=template&id=235717df&scoped=true"
import script from "./SMSTemplatesTab.vue?vue&type=script&lang=js"
export * from "./SMSTemplatesTab.vue?vue&type=script&lang=js"
import style0 from "./SMSTemplatesTab.vue?vue&type=style&index=0&id=235717df&prod&lang=scss&scoped=true"
import style1 from "./SMSTemplatesTab.vue?vue&type=style&index=1&id=235717df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235717df",
  null
  
)

export default component.exports